/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './authManageProfile.defs.js'
export * as $defs from './authManageProfile.defs.js'
